import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-412449b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-preview-data-wrap" }
const _hoisted_2 = { class: "block-preview-data" }
const _hoisted_3 = { class: "block-preview-data-header" }
const _hoisted_4 = { class: "block-preview-data-title" }
const _hoisted_5 = { class: "block-preview-data-body" }
const _hoisted_6 = { class: "block-preview-data-body-title-wrap" }
const _hoisted_7 = { class: "block-preview-data-body-title-block" }
const _hoisted_8 = { class: "block-preview-data-body-title" }
const _hoisted_9 = { class: "block-preview-data-title-image" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "block-preview-data-body-content" }

import {WrapTitle} from "@/entities";


export default /*#__PURE__*/_defineComponent({
  __name: 'block-preview-data',
  props: {
  bodyTitle: {
    type: String,
    default: "",
  },
  image: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "header-title")
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(WrapTitle), {
                text: __props.bodyTitle,
                size: "regular",
                weight: "700"
              }, null, 8, ["text"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: __props.image,
                alt: "image"
              }, null, 8, _hoisted_10)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _renderSlot(_ctx.$slots, "content")
        ])
      ])
    ])
  ]))
}
}

})